export class SiteOwnerAuthorisation {
  id: number;
  status: string;
  competencyNotes: string;
  expiryDate: string;
  siteOwnerName: string;
  email: string;
  firstName: string;
  lastName: string;

  public deserialize(input: any): this {
    this.id = input.id;
    this.status = input.status;
    this.competencyNotes = input.competencyNotes;
    this.expiryDate = input.expiryDate;
    this.siteOwnerName = input.siteOwnerName;
    this.email = input.email;
    this.firstName = input.firstName;
    this.lastName = input.lastName;
    return this;
  }
}